import customAxios from "../../customAxios";
import { ISignUp } from "../../../types/common.interface";
import { LOGIN } from "../../routes";

async function login(props: ISignUp) {
  var thisUrl = LOGIN;

  let body: any = {
    // role: props.role,
    userName: props.userName,
    password: props.password,
  };

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default login;
